<template>
  <FreeBottomSheet :name="name">
    <template #default>
      <div class="space-y-4 p-4">
        <section
          class="bg-background-neutral-secondary divide-situational-lightgrey space-y-2 divide-y rounded-2xl px-4 py-2"
        >
          <h3 class="flex items-center justify-between pt-2">
            <span class="text-text-neutral-secondary text-sm font-semibold">
              {{ t('main.loyalty.yourCashback') }}
            </span>
            <span class="freedom-loyalty-text text-2xl font-bold">
              {{ freedomCashbackDetails.totalCashback.value }}%
            </span>
          </h3>
          <div class="py-2">
            <CashbackDetail
              v-for="(details, idx) in freedomCashbackDetails.cashbackBreakdown
                .value"
              :key="idx"
              :details="details"
            />
          </div>
        </section>
        <LimitsInfo
          :level-title="
            freedomCashbackDetails.currentLoyaltyLevel.value?.title || ''
          "
          :transaction-limit="
            freedomCashbackDetails.currentLoyaltyLevel.value
              ?.limitPerTransaction || 0
          "
          :monthly-limit="
            freedomCashbackDetails.currentLoyaltyLevel.value?.limitPerMonth || 0
          "
        />
        <PriceInfo />
        <FreeButton
          type="button"
          class="green-main-button w-full"
          @click="closeBottomSheet"
        >
          {{ t('main.loyalty.goForTickets') }}
        </FreeButton>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { controllerModel } from 'shared';
  import { useI18n } from 'vue-i18n';
  import { FreeBottomSheet, FreeButton } from 'freedom-shared';

  import CashbackDetail from './CashbackDetail.vue';
  import LimitsInfo from './LimitsInfo.vue';
  import PriceInfo from './PriceInfo.vue';
  import { useFreedomCashbackDetails } from '../model';

  const props = defineProps<{
    name: string;
  }>();

  const { t } = useI18n();

  const freedomCashbackDetails = useFreedomCashbackDetails();

  const bottomSheet = controllerModel.useBottomSheet();

  const closeBottomSheet = () => {
    bottomSheet.hide(props.name);
  };
</script>
